import { css } from "@emotion/react";

import { colors } from "@styles";

export const link = css`
  white-space: nowrap;
`;

export const appColor = css`
  color: ${colors.blue.base};
`;
